const CardBackground = [
  "https://media.discordapp.net/attachments/1012001449854648480/1051460965834694676/1.png",
  "https://media.discordapp.net/attachments/1012001449854648480/1051460966224756776/2.png",
  "https://media.discordapp.net/attachments/1012001449854648480/1051460966698717204/3.png",
  "https://media.discordapp.net/attachments/1012001449854648480/1051460967193649162/4.png",
];

export default CardBackground;
